import React, { Component } from "react";
import {
  CircularProgress,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  DialogActions,
  Dialog,
  Tooltip,
} from "@material-ui/core";
import { Translation } from "react-i18next";
import { MenuItem } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import { MdExplicit } from "react-icons/md";
import getAllRadioStations from "../../../util/sys-calls/getAllRadioStations";
import { _PermittedContent } from "../../../_module/utils/PermittedContent";

import { FiRotateCcw, FiTrash2, FiEdit2, FiArchive } from "react-icons/fi";
import { BiBlock } from "react-icons/bi";
import HelpWrap from "../../ml-admin/help-admin/help-view/HelpWrap";
import { helpModules } from "../../ml-admin/help-admin/help-view/Const";
import DownloadLink from "../../../util/downloader/DownloadLink";
import DownloadXMLLink from "../../../util/content-util/DownloadXMLLink";
import PrsSearchButton from "util/prs-search/prs-search-button/PrsSearchButton";
import { prsSearchRefreshDataType } from "util/prs-search/const";
import { bulkEditStringTypes, bulkEditTypes } from "redux/Types";
import PermittedContent from "_module/component/permitted-content/PermittedContent";
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';

class ContentMenu extends Component {
  constructor(props) {
    super();
    this.state = {
      messageOpen: false,
      rList: null,
      confMsg: "",
      onConfirmAction: null,
      externalMessageOpen: false,
    };
  }

  filterChangeTimer = null;

  handlePublishToPlayout = (event) => {
    const { filteredOptions, allOptions } = this.state;

    event.stopPropagation();
    if (allOptions.length < 1) {
      this.getAllStations();
    } else {
      this.setState({ filteredOptions: this.state.allOptions });
    }
    this.setState({ anchorEl: null });
    this.setState({ messageOpen: true });
  };

  getAllStations() {
    getAllRadioStations().then((items) => {
      const options = items;
      this.setState({ allOptions: options, filteredOptions: options });
    });
  }

  copyExternalTrack = (e) => {
    const {
      data: { editing },
      copyTrack,
      row,
      history,
      contentTrackEditItem,
    } = this.props;

    copyTrack("Please wait...", { trackOrgId: row.id }, (action) => {
      // if (sessionid) {
      //   history.push("/uploads/session/" + sessionid);
      // }
      contentTrackEditItem(action);
    });
  };

  // handleEditAction = (event) => {
  //   const { row, GetUpdateTrack, handleClose, emptySession } = this.props;
  //   emptySession();
  //   GetUpdateTrack("Fetching Data...", { "track_id": row.id, "workspaceId": row.wsId, "source": "DH_EDIT", "dhTrackId": row.dhTrackId }, (data) => {
  //     if (!data) {
  //       alert("something went wrong. please try again!")
  //     }
  //     else if (data.wsType == 'External') {
  //       this.handeConfirmMessageOpen('COPY_TRACK', 'This is an External Workspace Track. Do you want to copy and edit the track?');
  //     } else {
  //       handleClose(event);
  //           }
  //   });
  // };

  createBulkEditJobId = async (
    selectedBulkTrackItems,
    selectedBulkAlbumItems,
    selectedBulkTrackMeta,
    bulkEditType
  ) => {
    const { createTrackBulkEdit } = this.props;
    try {
      const data = await new Promise((resolve, reject) => {
        createTrackBulkEdit(
          {
            selected_tracks: selectedBulkTrackItems,
            selected_albums: selectedBulkAlbumItems,
            type: bulkEditType,
            track_meta: selectedBulkTrackMeta,
          },
          (data, error) => {
            if (data) {
              if (data) {
                resolve(data);
              }
            } else if (error) {
              reject(error);
            }
          }
        );
      });
      return data;
    } catch (error) {
      console.error("Error in createBulkEditJobId:", error);
    }
  };

  handleOpenWindow = async (e) => {
    const {
      row,
      tracks,
      handleClose,
      data: { items },
      user: {
        credentials: { orgID },
      },
    } = this.props;

    let selectedAlbumIdsSet = new Set(
      items
        .filter((item) => tracks.includes(item?.id))
        .map((item) => item?.prodId)
    );

    let selectedAlbumIds = [...selectedAlbumIdsSet].filter(
      (id) => id !== null && id !== undefined
    );

    if (selectedAlbumIds.length === 0) {
      selectedAlbumIds = null;
    }

    const bulkEditType = bulkEditStringTypes.TRACK;
    //const trackSearch = bulkEditStringTypes.SEARCH;
    const trackMeta = {};
    const albumMeta = {};
    items.forEach((item) => {
      if (tracks.includes(item?.id)) {
        if (!trackMeta[item?.id]) {
          trackMeta[item.id] = {
            prodId: item?.prodId,
            dhTrackId: item?.dhTrackId,
            wsId: item?.wsId,
            wsType: item?.wsType,
          };
        }
      }
    });

    const jobId = await this.createBulkEditJobId(
      tracks,
      selectedAlbumIds,
      trackMeta,
      bulkEditTypes.TRACK
    );

    if (jobId) {
      if (jobId) {
        const width = Math.min(window.screen.width * 0.75);
        const height = Math.min(window.innerHeight * 0.75);
        const left = (window.screen.width - width) / 2;
        const top = (window.screen.height - height) / 3;
        window.open(
          `${process.env.PUBLIC_URL}/uploads/${bulkEditType}/bulk-edit/${orgID}/${jobId}`,
          "_blank",
          `toolbar=0,location=0,menubar=0,statusbar=0,directories=0,status=0,scrollbars=0,copyhistory=0,width=${width},height=${height},top=${top},left=${left}`
        );
      }
      handleClose();
    }
  };

  onFilterChange = (e) => {
    const { loadRecent, setRecentQuery, recentQuery } = this.props;
    var filter = e.currentTarget.value;
    setRecentQuery(filter);
    clearTimeout(this.filterChangeTimer);
    this.filterChangeTimer = setTimeout(() => {
      loadRecent({ ...recentQuery, q: filter });
    }, 400);
  };

  onConfirm = (e, action) => {
    const { tracks, handleClose } = this.props;

    //handleClose(e);
    if (tracks?.length > 0 && action) {
      switch (action) {
        case "EXPICIT_CONTENT":
          handleClose(e);
          this.handleExplicitContent(e);
          break;

        case "UNDO_EXPICIT_CONTENT":
          handleClose(e);
          this.handleUndoExplicitContent(e);
          break;

        case "EDIT_TRACK":
          this.handleOpenWindow(e);
          break;

        case "COPY_TRACK":
          handleClose(e);
          this.copyExternalTrack(e);
          break;

        case "REMOVE_TRACK":
          handleClose(e);
          this.handleRemoveAction(e);
          break;

        case "ARCHIVE":
          handleClose(e);
          this.restrictArchive(e, "ARCHIVE_TRACK");
          break;

        case "RESTRICT":
          handleClose(e);
          this.restrictArchive(e, "RESTRICT_TRACK");
          break;

        case "UNDO_RESTRICT":
          handleClose(e);
          this.restrictArchive(e, "REMOVE_RESTRICT_TRACK");
          break;

        case "CONTENT_ALERT":
          handleClose(e);
          this.contentAlert(e, "CONTENT_ALERT");
          break;
        case "SHOW_TRACK":
        case "HIDE_TRACK":
          handleClose(e);
          this.showHideTrack(e, action);
          break;
      }
    }
  };

  restrictArchive = (event, action) => {
    event.stopPropagation();
    this.setState({ anchorEl: null });
    const { row, MLPostItem } = this.props;
    MLPostItem(action, `1 in progress ...`, [row.id], null, "track");
  };

  showHideTrack = (event, action) => {
    event.stopPropagation();
    this.setState({ anchorEl: null });
    const { row, showHideTrack, showAutoMessageMainSearch } = this.props;
    showHideTrack(action, `${action == "HIDE_TRACK" ? "Hiding" : "Unhiding"} track in progress ...`, [row.id], null, "track",(data, error) => {
      if (data) {
        showAutoMessageMainSearch(`${action == "HIDE_TRACK" ? "Hiding" : "Unhiding"} track is scheduled. This may take a while to reflect in search.`);
      }else if(error){
        showAutoMessageMainSearch("Something went Wrong!, Please try again")
      }
    });
  };

  canRestrictTracks = () => {
    const {
      orgRuntime: {
        runtime: { _mlContentAdmin, _mlContentCanManageRestricted },
      },
    } = this.props;
    let canRestrict = _PermittedContent(
      [_mlContentAdmin, _mlContentCanManageRestricted],
      []
    )
      ? true
      : false;
    return canRestrict;
  };

  canArchiveTracks = () => {
    const {
      orgRuntime: {
        runtime: { _mlContentAdmin, _mlContentCanArchive },
      },
    } = this.props;
    let canArchive = _PermittedContent(
      [_mlContentAdmin, _mlContentCanArchive],
      []
    )
      ? true
      : false;
    return canArchive;
  };

  canExplicitContent = () => {
    const {
      orgRuntime: {
        runtime: { _mlContentAdmin, _mlContentCanExplicitContent },
      },
    } = this.props;
    let canArchive = _PermittedContent(
      [_mlContentAdmin, _mlContentCanExplicitContent],
      []
    )
      ? true
      : false;
    return canArchive;
  };

  canDeleteTracks = () => {
    const {
      orgRuntime: {
        runtime: { _mlContentAdmin, _mlContentCanDeleteTracks },
      },
    } = this.props;
    let canArchive = _PermittedContent(
      [_mlContentAdmin, _mlContentCanDeleteTracks],
      []
    )
      ? true
      : false;
    return canArchive;
  };

  canEditTracks = () => {
    const {
      orgRuntime: {
        runtime: { _mlContentAdmin, _mlContentCanEditTracksAndAlbums },
      },
    } = this.props;
    let canArchive = _PermittedContent(
      [_mlContentAdmin, _mlContentCanEditTracksAndAlbums],
      []
    )
      ? true
      : false;
    return canArchive;
  };

  canDownloadMetadataXML = () => {
    const {
      orgRuntime: {
        runtime: { _mlMetadata, _canDownloadMetadataXML },
      },
    } = this.props;
    let canDownloadXML = _PermittedContent(
      [_mlMetadata, _canDownloadMetadataXML],
      []
    )
      ? true
      : false;
    return canDownloadXML;
  };

  handleRemoveAction = (event) => {
    event.stopPropagation();
    this.setState({ anchorEl: null });
    const { row, RemoveTrack, showAutoMessageMainSearch } = this.props;
    RemoveTrack(
      "Removing Track...",
      { track_ids: [row.id], source: "TRACK_REMOVE", workspaceId: row.wsId },
      (data) => {
        if (!data.data) {
          showAutoMessageMainSearch("Something went wrong. please try again!");
        } else {
          if (data.data == -2) {
            showAutoMessageMainSearch(
              "This is an external workspace track, You cannot delete this track!"
            );
          } else {
            this.reloadData();
          }
        }
      }
    );
  };

  _isSandBox() {
    return this.props.location.pathname === "/mladmin/trackranking";
  }

  reloadData = () => {
    const {
      mainProps: {
        data: { query },
      },
      search,
    } = this.props;
    search(query, this._isSandBox());
  };

  handleMessageConfirm = (e) => {
    const { onConfirmAction } = this.state;
    this.onConfirm(e, onConfirmAction);
    this.setState({ messageOpen: false });
  };

  handeConfirmMessageOpen = (action, confMsg) => {
    this.setState({
      messageOpen: true,
      onConfirmAction: action,
      confMsg: confMsg,
    });
  };

  handleCloseMessage = () => {
    this.setState({ messageOpen: false });
    const { handleClose, focusItem, row } = this.props;
    handleClose();
  };

  handleUndoExplicitContent = (event) => {
    event.stopPropagation();
    const { row, removeExplicitRule, showAutoMessage } = this.props;

    let ctagId = 0;
    if (row.cTagList && row.cTagList.length > 0) {
      row.cTagList.map((rule) => {
        if (rule.ctagId == process.env.REACT_APP_CONTENT_EXPLICIT_TAG) {
          ctagId = rule.ctagId;
        }
      });
    }
    removeExplicitRule(
      "Please wait...",
      [{ trackId: row.id, cTagIds: [ctagId] }],
      (data) => {
        if (data > 0) {
          this.reloadData();
          showAutoMessage(`${data} rule(s) removed`);
        } else {
          showAutoMessage(`${data} rule(s) removed`);
        }
      }
    );
  };

  checkExplicitTag = () => {
    const { row } = this.props;
    var isExplicit = true;
    if (!row.cTagList) {
      isExplicit = true;
    } else {
      row.cTagList.map((rule) => {
        if (rule.ctagId == process.env.REACT_APP_CONTENT_EXPLICIT_TAG) {
          isExplicit = false;
        }
      });
    }
    return isExplicit;
  };

  contentAlert = (event) => {
    const { row, contentAlert, showAutoMessage } = this.props;

    contentAlert(
      "Please wait...",
      [{ refId: row.id, contentAlert: true, type: "TRACK" }],
      (data) => {
        if (data > 0) {
          this.reloadData();
          showAutoMessage(`${data} rule(s) removed`);
        } else {
          showAutoMessage(`${data} rule(s) removed`);
        }
      }
    );
  };

  handleExplicitContent = (event) => {
    event.stopPropagation();

    const { showMessage, row, CtagSave, showAutoMessage } = this.props;

    let editedRule = [];
    let orRule = {};
    let defaultRule = {};
    let andRule = {};
    let ruleToAdd = {
      color: "#ffffff",
      name: "",
      rules: "",
      track_id: row.id,
      status: 1,
    };

    if (row.trackTitle) {
      ruleToAdd.name = row.trackTitle;

      //Add default Item as Title
      defaultRule = {
        defaultItem: {
          property: "trackTitle",
          condition: 1,
          innerProperty: null,
          value: row.trackTitle,
        },
      };
      editedRule.push(defaultRule);

      //Add Artists
      if (row.performer && row.performer.length > 0) {
        for (var i = 0; i < row.performer.length; i++) {
          andRule = {
            and: {
              property: "performer",
              condition: 1,
              value: row.performer[i],
            },
          };
          editedRule.push(andRule);
        }
      }

      //Add ISRC
      if (row.isrc) {
        ruleToAdd.name = row.isrc;
        orRule = {
          or: [
            {
              property: "isrc",
              condition: 1,
              value: row.isrc,
            },
          ],
        };
        editedRule.push(orRule);
      }
    }

    ruleToAdd.rules = JSON.stringify(editedRule);

    CtagSave("SAVE_EXPLICIT", "Adding rule..", ruleToAdd, (data, error) => {
      if (error) {
        showAutoMessage("Something went wrong, please retry");
      }
      if (data) {
        showAutoMessage("Rule added");
        this.reloadData();
      }
    });
  };

  render() {
    const {
      classes,
      busy,
      handleClose,
      handlePublishToPlayout,
      tracks,
      row,
      showAutoMessageMainSearch,
      mainProps: { downloadXML },
      bulkEditData: { loading },
      orgRuntime: {
        runtime: { _uploads, _mlLibraries, _libraryCanHideUnhideTracks },
      },
    } = this.props;
    const { messageOpen, confMsg, externalMessageOpen } = this.state;

    return (
      <Translation>
        {(t, { i18n }) => (
          <>
            <Dialog
              open={messageOpen}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              className={classes.dialogWrapper}
              class="dialogBox">
              <DialogTitle id="alert-dialog-title">
                {"Confirmation Alert"}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  {confMsg}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  className={classes.dialogYesButton}
                  onClick={(e) => {
                    this.handleMessageConfirm(e);
                  }}
                  color="primary"
                  autoFocus>
                  Yes
                </Button>
                <Button
                  className={classes.dialogNoButton}
                  onClick={this.handleCloseMessage}
                  color="primary">
                  No
                </Button>
              </DialogActions>
            </Dialog>

            {/* {busy && <CircularProgress className={classes.circularProgress} />} */}

            <PrsSearchButton
              classes={classes}
              trackID={row.dhTrackId}
              id={row.dhTrackId}
              handleClose={handleClose}
              prsSearchRefreshDataType={prsSearchRefreshDataType.TRACK}
              helpComponentModule={helpModules.TSRCMPRS}
              isDisabled={row?.prsMechanicalOverride || false}
            />
            <PermittedContent modulePath={_uploads}>
              <MenuItem
                id={`context-edit-track-${row.id}`}

                disabled={!this.canEditTracks()}
                onClick={(e) => {
                  this.handleOpenWindow(e);
                }}>
                <FiEdit2 className={classes.contextIcons} /> Edit
                {loading && (
                  <div className={classes.circularBulkEdit}>
                    <CircularProgress
                      size={20}
                      className={classes.bulkEditLoading}
                    />
                  </div>
                )}
                <HelpWrap config={helpModules.TSRCMEDT} />
              </MenuItem>
            </PermittedContent>
            <MenuItem
              id={`context-remove-track-${row.id}`}

              disabled={!this.canEditTracks()}
              onClick={(e) => {
                this.handeConfirmMessageOpen(
                  "REMOVE_TRACK",
                  "Are you sure, you want to delete the track?"
                );
              }}>
              <FiTrash2 className={classes.contextIcons} /> Delete
              <HelpWrap config={helpModules.ATRCM_Delete} />
            </MenuItem>

            {this.checkExplicitTag() ? (
              <MenuItem
                id={`context-explicit-content-${row.id}`}
                disabled={!this.canExplicitContent()}
                onClick={(e) => {
                  this.handeConfirmMessageOpen(
                    "EXPICIT_CONTENT",
                    "Are you sure, you want to add this track to explicit list?"
                  );
                }}>
                <MdExplicit className={classes.contextIcons} /> Explicit Content
                <HelpWrap config={helpModules.TSRCMExplicitContent} />
              </MenuItem>
            ) : (
              <MenuItem
                id={`context-undo-explicit-content-${row.id}`}

                disabled={!this.canExplicitContent()}
                onClick={(e) => {
                  this.handeConfirmMessageOpen(
                    "UNDO_EXPICIT_CONTENT",
                    "Are you sure, you want to remove this explicit rule?"
                  );
                }}>
                <MdExplicit className={classes.contextIcons} /> Undo Explicit
                Content
                <HelpWrap config={helpModules.TSRCMExplicitContent} />
              </MenuItem>
            )}
            {!row.restricted && (
              <MenuItem
                id={`context-restrict-track-${row.id}`}
                disabled={!this.canRestrictTracks()}
                onClick={(e) => {
                  this.handeConfirmMessageOpen(
                    "RESTRICT",
                    "Are you sure, you want to restrict the track?"
                  );
                }}>
                <BiBlock className={classes.contextIcons} /> Restrict Content
                <HelpWrap config={helpModules.TSRCMRestrict} />
              </MenuItem>
            )}

            {row.restricted && (
              <MenuItem
                id={`context-undo-restrict-track-${row.id}`}
                disabled={!this.canRestrictTracks()}
                onClick={(e) => {
                  this.handeConfirmMessageOpen(
                    "UNDO_RESTRICT",
                    "Are you sure, you want to undo the restriction of this track?"
                  );
                }}>
                <BiBlock className={classes.contextIcons} /> Undo Restrict
                Content
                <HelpWrap config={helpModules.TSRCMUndoRestrict} />
              </MenuItem>
            )}

            <DownloadLink
              isMenuItem="true"
              showAutoMessage={showAutoMessageMainSearch}
              closeFunction={handleClose}
              track={row}
            />

            {this.canDownloadMetadataXML() && (
              <DownloadXMLLink
                isMenuItem="true"
                showAutoMessage={showAutoMessageMainSearch}
                closeFunction={handleClose}
                track={row}
                id={row.id}
                downloadXML={downloadXML}
              />
            )}

            {!row.archived && (
              <MenuItem

                id={`context-track-archive-${row.id}`}
                disabled={!this.canArchiveTracks()}
                onClick={(e) => {
                  this.handeConfirmMessageOpen(
                    "ARCHIVE",
                    "Are you sure, you want to archive the track?"
                  );
                }}>
                <FiArchive className={classes.contextIcons} /> Archive
                <HelpWrap config={helpModules.TSRCMArchive} />
              </MenuItem>
            )}

            {row.archived && (
              <MenuItem

                id={`context-track-restore-${row.id}`}
                disabled={!this.canArchiveTracks()}
                onClick={(e) => {
                  this.handeConfirmMessageOpen(
                    "RESTORE",
                    "Are you sure, you want to restore track?"
                  );
                }}>
                <FiRotateCcw className={classes.contextIcons} /> Restore
                <HelpWrap config={helpModules.TSRCMRestore} />
              </MenuItem>
            )}

            <PermittedContent modulePath={[_mlLibraries, _libraryCanHideUnhideTracks]}>

              <Tooltip title="Show selected track in search results" placement="right">
                <MenuItem
                  onClick={(e) => {
                    e.stopPropagation();
                    this.handeConfirmMessageOpen(
                      "SHOW_TRACK",
                      "Are you sure, you want to show the hidden track in the search?"
                    );
                  }}
                  disabled={!row?.hide || false}
                >

                  <VisibilityIcon className={classes.actionMenuIcon} />{" "}
                  Show in Search
                </MenuItem>
              </Tooltip>

              <Tooltip title="Hide selected track from search results" placement="right">
                <MenuItem
                  onClick={(e) => {
                    e.stopPropagation();
                    this.handeConfirmMessageOpen(
                      "HIDE_TRACK",
                      "Are you sure, you want to hide the track from search?"
                    );
                  }}
                disabled={row?.hide || false}
                >

                  <VisibilityOffIcon className={classes.actionMenuIcon} />{" "}
                  Hide from Search
                </MenuItem>
              </Tooltip>

            </PermittedContent>

            {/* <MenuItem
              disabled={!this.canArchiveTracks()}
              onClick={(e) => {
                this.handeConfirmMessageOpen(
                  "CONTENT_ALERT",
                  "Are you sure, you want to alert?"
                );
              }}
            >
              <FiRotateCcw className={classes.contextIcons} /> Content Alert
              <HelpWrap config={helpModules.TSRCMRestore} />
            </MenuItem> */}
          </>
        )}
      </Translation>
    );
  }
}

export default withRouter(ContentMenu);
